export default "skymp5-front/5aaaa9bb93497bdf7fded7f9007eb15e.gif";